module.exports = __webpack_public_path__ + "img/25-Immunity.48f5e60a.png";